import { useState } from 'react';
import { usePopupHistory } from '@/shared/hooks/usePopupHistory';

interface UsePdpBuyActionsOptions {
  onBuyNow?: () => void;
  onBuyNowClick?: () => void;
  onGmsPlanOpen?: (monthlyAmount: number) => void;
}

export function usePdpBuyActions({
  onBuyNow,
  onBuyNowClick,
  onGmsPlanOpen,
}: UsePdpBuyActionsOptions = {}) {
  const [isGmsSheetOpen, setIsGmsSheetOpen] = useState(false);

  const handleCloseGmsSheet = () => {
    setIsGmsSheetOpen(false);
  };

  const { goBack } = usePopupHistory({
    isOpen: isGmsSheetOpen,
    onClose: handleCloseGmsSheet,
    stateKey: 'goldMinePlan',
  });

  const handleOpenGmsSheet = (monthlyAmount: number) => {
    onGmsPlanOpen?.(monthlyAmount);
    setIsGmsSheetOpen(true);
  };

  const handleBuyNow = () => {
    onBuyNowClick?.();
    onBuyNow?.();
  };

  return {
    isGmsSheetOpen,
    handleOpenGmsSheet,
    handleBuyNow,
    handleCloseGmsSheet: goBack,
  };
}
